<script setup>
	const props = defineProps({
		title: String
	})
</script>

<template>
	<div class="notification-wr" v-html="title" />
</template>

<style lang='scss'>
.notification-wr {
	margin-top: 12px;
	padding: 16px;
	border-radius: 12px;
	line-height: 20px !important;
	background-color: $softYellow;
	font-size: 14px;
}
</style>